"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TextField = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const TextField = ({
  label,
  placeholder,
  className,
  labelClassName,
  error,
  errorMessage,
  disabled,
  type,
  fieldName,
  helperText,
  value,
  showPasswordIcon,
  loading,
  showPasswordIconElement,
  hidePasswordIconElement,
  useDefaultPasswordIconImage,
  ...rest
}) => {
  const [showPassword, setShowPassword] = (0, _react.useState)(false);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sp-pt--48"
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: `spta-label ${labelClassName}`,
    htmlFor: "name"
  }, label), fieldName === "textarea" ? /*#__PURE__*/_react.default.createElement("textarea", _extends({
    className: `spta-textarea 
        ${error && "spta-textarea__error"} ${className}`,
    placeholder: placeholder,
    disabled: disabled,
    value: value
  }, rest)) : /*#__PURE__*/_react.default.createElement("div", {
    className: "input"
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    className: `input__text ${error && "spta-textarea__error"} ${className}`,
    type: showPassword ? showPassword === true ? "text" : "password" : type,
    value: value,
    placeholder: placeholder,
    disabled: disabled
  }, rest)), loading && /*#__PURE__*/_react.default.createElement("button", {
    className: "input__btn"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "ri-loader-4-fill"
  })), showPasswordIcon && /*#__PURE__*/_react.default.createElement("button", {
    className: "input__btn",
    onClick: () => setShowPassword(!showPassword)
  }, useDefaultPasswordIconImage ? showPassword ? /*#__PURE__*/_react.default.createElement("i", {
    className: "ri-eye-line"
  }) : /*#__PURE__*/_react.default.createElement("i", {
    className: "ri-eye-off-line"
  }) : showPassword ? hidePasswordIconElement ?
  /*#__PURE__*/
  // Passing elements / text as toggle items for password field
  _react.default.createElement(_react.Fragment, null, hidePasswordIconElement) : "Hide" : showPasswordIconElement ?
  /*#__PURE__*/
  // Passing elements / text as toggle items for password field
  _react.default.createElement(_react.Fragment, null, showPasswordIconElement) : "Show")), /*#__PURE__*/_react.default.createElement("small", {
    className: "input__text--helper"
  }, helperText), error && errorMessage && /*#__PURE__*/_react.default.createElement("small", {
    className: "spta-textarea__error--message"
  }, errorMessage));
};

exports.TextField = TextField;
TextField.defaultProps = {
  error: false,
  disabled: false,
  type: "text",
  fieldName: "input",
  showPasswordIcon: false,
  loading: false,
  useDefaultPasswordIconImage: false
};
TextField.propTypes = {
  label: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  className: _propTypes.default.string,
  errorMessage: _propTypes.default.string,
  error: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  helperText: _propTypes.default.string,
  value: _propTypes.default.string,
  type: _propTypes.default.string,
  labelClassName: _propTypes.default.string,
  showPasswordIcon: _propTypes.default.bool,
  useDefaultPasswordIconImage: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  fieldName: _propTypes.default.oneOf(_utils.enums.fieldName),
  showPasswordIconElement: _propTypes.default.string,
  hidePasswordIconElement: _propTypes.default.string
};
var _default = TextField;
exports.default = _default;